import React, { useState } from 'react';
import { TextField, TextareaField, ToggleField } from '../../../components/orizon-ui/FormField';
import { gruCrea, gruAggiorna } from '../../../lib/services/gruService';
import FormModal, { useFormSalva, useSporco } from '../../../components/gru/FormModal';
import SezioneConfig, { colonnaAttivo } from './SezioneConfig';
import { vuoto } from '../utils';

const FormGru = ({ record, onClose, onSaved }) => {
  const modifica = Boolean(record);
  const [form, setForm] = useState({
    codice: record?.codice ?? '',
    nome: record?.nome ?? '',
    descrizione: record?.descrizione ?? '',
    attivo: record?.attivo ?? true,
  });
  const { salvando, errori, impostaErrori, pulisci, salva } = useFormSalva();
  const sporco = useSporco(form);

  const imposta = (campo) => (valore) => {
    setForm((prec) => ({ ...prec, [campo]: valore }));
    pulisci(campo);
  };

  const invia = async () => {
    const nuovi = {};
    if (vuoto(form.codice)) nuovi.codice = 'Obbligatorio';
    if (vuoto(form.nome)) nuovi.nome = 'Obbligatorio';
    impostaErrori(nuovi);
    if (Object.keys(nuovi).length) return;

    const payload = {
      codice: form.codice.trim(),
      nome: form.nome.trim(),
      descrizione: vuoto(form.descrizione) ? null : form.descrizione.trim(),
      attivo: form.attivo,
    };

    await salva(
      () => (modifica ? gruAggiorna('gru', record.id, payload) : gruCrea('gru', payload)),
      modifica ? 'Gru aggiornata.' : 'Gru creata.',
      onSaved,
    );
  };

  return (
    <FormModal
      titolo={modifica ? 'Modifica gru' : 'Nuova gru'}
      etichetta="Configurazione · Gru"
      larghezza="md"
      sporco={sporco}
      salvando={salvando}
      onClose={onClose}
      onSubmit={invia}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <TextField label="Codice" name="codice" value={form.codice} onChange={imposta('codice')} obbligatorio errore={errori.codice} mono autoFocus placeholder="es. GRU-01" />
        <TextField label="Nome" name="nome" value={form.nome} onChange={imposta('nome')} obbligatorio errore={errori.nome} placeholder="es. Carroponte acciaieria" />
      </div>
      <TextareaField label="Descrizione" name="descrizione" value={form.descrizione} onChange={imposta('descrizione')} errore={errori.descrizione} />
      <ToggleField label="Attiva" sublabel={form.attivo ? 'Selezionabile negli interventi' : 'Non selezionabile'} checked={form.attivo} onChange={imposta('attivo')} />
    </FormModal>
  );
};

const COLONNE = [
  { key: 'codice', label: 'Codice', width: 140, render: (r) => <span className="font-mono text-[12px] font-bold text-foreground/80">{r.codice}</span> },
  { key: 'nome', label: 'Nome', width: 240, render: (r) => <span className="text-[13px] font-black uppercase tracking-tight text-foreground/80">{r.nome}</span> },
  { key: 'descrizione', label: 'Descrizione', width: 320, render: (r) => <span className="text-[12px] font-medium text-muted-foreground">{r.descrizione || '---'}</span> },
  colonnaAttivo,
];

const TabGru = () => (
  <SezioneConfig
    entita="gru"
    titolo="Gru"
    descrizione="Carriponti dell'impianto"
    nuovoLabel="Nuova gru"
    colonne={COLONNE}
    ordineIniziale={{ key: 'codice', direction: 'asc' }}
    FormComponent={FormGru}
    labelRiga={(r) => `${r.codice} — ${r.nome}`}
    messaggioVuoto="Nessuna gru configurata"
  />
);

export default TabGru;
